query Studios($input: StudioQueryInput!) {
  queryStudios(input: $input) {
    count
    studios {
      id
      name
      deleted
      parent {
        id
        name
      }
      is_favorite
    }
  }
}
